import Layout from "../../components/global/layout"
import { IoEyeOutline } from "react-icons/io5";
import { useEffect, useState } from "react";
import loader from "../../methods/loader";
import ApiClient from "../../methods/api/apiClient";
import { Tooltip } from "antd";
import FormControl from "../../components/common/FormControl";
import Pagination from "react-js-pagination";
import { IoMdClose } from "react-icons/io";
import { useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import SelectDropdown from "../../components/common/SelectDropdown";

const MyTransactions = () => {
    const [data, setData]: any = useState([])
    const navigate = useNavigate()
    const user = useSelector((state: any) => state.user)
    const [filter, setFilter] = useState({ page: 1, count: 10, search: "", total: 0, transaction_status: "" })

    const transactionStatusOptions = [
        { id: "successful", name: "Successful" },
        { id: "pending", name: "Pending" },
    ]

    useEffect(() => {
        getData()
    }, [])

    const getData = (f = {}) => {
        const payload: any = { ...filter, ...f, userId: user?._id || user?.id }
        loader(true)
        delete payload?.total // No need for total key
        ApiClient.get(`transactions/list`, payload).then(res => {
            if (res.success) {
                setData(res?.data)
                setFilter((prev: any) => ({ ...prev, total: res?.total }))
            }
            loader(false)
        })
    }

    const handleSearch = (e: any) => {
        e.preventDefault()
        getData({ search: filter?.search })
    }

    const clear = () => {
        setFilter((prev: any) => ({ ...prev, search: "" }))
        getData({ search: "" })
    }

    const handlePagination = (e: any) => {
        setFilter({ ...filter, page: e });
        getData({ page: e });
    };

    const handleFilters = (value: string, key: string) => {
        setFilter({ ...filter, [key]: value });
        getData({ [key]: value });
    }

    return (
        <>
            <Layout>
                <div>
                    <div className="section-listinngs px-4 lg:px-16 pt-6">
                        <div className="mb-10 flex items-center justify-between">
                            <h4 className="text-[30px] text-[#292F36]">My Transactions</h4>
                            <div className="flex items-center gap-4">
                                <form onSubmit={handleSearch} className="relative">
                                    <FormControl
                                        type="text"
                                        name="search"
                                        value={filter?.search}
                                        onChange={(e: any) => setFilter((prev: any) => ({ ...prev, search: e }))}
                                        placeholder="Search..."
                                        className="relative shadow bg-white border border-gray-100 w-full rounded-lg h-12 flex items-center gap-2 overflow-hidden px-2"
                                    />
                                    {filter?.search && <IoMdClose size={18} onClick={e => clear()} className="absolute top-3 right-2 hover:text-red-600 cursor-pointer" />}
                                    <button type="submit" className="hidden"></button>
                                </form>
                                <div>
                                    <SelectDropdown
                                        id="statusDropdown"
                                        displayValue="name"
                                        placeholder="All Transaction Status"
                                        theme="search"
                                        isClearable={true}
                                        intialValue={filter?.transaction_status}
                                        result={(e: any) => { handleFilters(e.value, "transaction_status") }}
                                        options={transactionStatusOptions}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-4 xl:gap-8">
                            <div className="col-span-12 md:col-span-12">
                                <div className="overflow-auto">
                                    <table className="w-full">
                                        <thead className="bg-[#F6EFE9] mb-4">
                                            <tr className="">
                                                <th className="text-left px-4">Date</th>
                                                <th className="text-left px-4">Product Name</th>
                                                <th className="text-left px-4">Transaction Status</th>
                                                <th className="text-left px-4">Price</th>
                                                <th className="text-left px-4"></th>
                                            </tr>
                                        </thead>
                                        <tbody className="">
                                            {data?.map((item: any, index: number) => {
                                                return <tr className="mt-4 border-t border-gray-200" key={index}>
                                                    <td className="px-4 p-4">{moment(item?.createdAt).format("DD MMM, YYYY")}</td>
                                                    <td className="capitalize">
                                                        {item?.cardDetails?.map((itm: any, i: number) => {
                                                            return <span className="bg-primary p-2 rounded-lg text-white mr-2" key={i}>{itm?.customizeCardDetail?.name}</span>
                                                        })}
                                                    </td>
                                                    <td className="capitalize">{item?.transaction_status}</td>
                                                    <td>${item?.isPromo === "yes" ? item?.discountedAmount : item?.IncludingTaxAmount || item?.totalAmount || 0}</td>
                                                    <td>
                                                        <Tooltip title="View">
                                                            <IoEyeOutline onClick={e => { navigate(`/transaction/detail/${item?._id || item?.id}`) }} className="text-xl cursor-pointer hover:text-[#F58D18]" />
                                                        </Tooltip>
                                                    </td>
                                                </tr>
                                            })}
                                            {data?.length === 0 &&
                                                <tr className="text-center">
                                                    <td className="px-4 p-4" colSpan={5}>
                                                        No Transaction
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                    {filter?.total > filter?.count ?
                                        <div className="mt-10 flex items-center justify-end">
                                            <Pagination
                                                activePage={filter?.page}
                                                itemsCountPerPage={filter?.count}
                                                totalItemsCount={filter?.total}
                                                pageRangeDisplayed={1}
                                                onChange={handlePagination}
                                                hideFirstLastPages={true}
                                            />
                                        </div>
                                        : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default MyTransactions